
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["font-color",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.68 20.69"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Vrstva_2","data-name":"Vrstva 2"}},[_c('g',{attrs:{"id":"Vrstva_1-2","data-name":"Vrstva 1"}},[_c('path',{attrs:{"d":"M20.63 6.08a7.49 7.49 0 00-.48-2.51A5.06 5.06 0 0019 1.74 4.83 4.83 0 0017.12.55a7.41 7.41 0 00-2.51-.49C13.51 0 13.16 0 10.35 0S7.19 0 6.08.06a7.75 7.75 0 00-2.51.48 5.06 5.06 0 00-1.83 1.2A4.91 4.91 0 00.55 3.57a7.46 7.46 0 00-.49 2.51C0 7.19 0 7.54 0 10.35s0 3.16.06 4.26a7.69 7.69 0 00.48 2.51A5 5 0 001.74 19a5.06 5.06 0 001.83 1.2 7.75 7.75 0 002.51.48c1.1.05 1.45.06 4.26.06s3.16 0 4.27-.06a7.75 7.75 0 002.51-.48 5.27 5.27 0 003-3 7.25 7.25 0 00.48-2.51c.05-1.1.06-1.45.06-4.26s.02-3.24-.03-4.35zm-1.86 8.45a5.8 5.8 0 01-.36 1.92 3.38 3.38 0 01-2 2 5.8 5.8 0 01-1.92.36c-1.09.05-1.42.06-4.18.06s-3.09 0-4.18-.06a5.87 5.87 0 01-1.92-.36 3.14 3.14 0 01-1.19-.77 3.26 3.26 0 01-.77-1.19 5.61 5.61 0 01-.35-1.92c-.05-1.09-.06-1.42-.06-4.18s0-3.09.06-4.17a5.61 5.61 0 01.35-1.92 3.16 3.16 0 01.78-1.19 3 3 0 011.23-.81 5.31 5.31 0 011.92-.36c1.09-.05 1.41-.06 4.17-.06s3.1 0 4.18.06a5.31 5.31 0 011.92.36 3 3 0 011.19.77 3.14 3.14 0 01.77 1.19 5.8 5.8 0 01.36 1.92c.05 1.09.06 1.41.06 4.17s-.01 3.09-.06 4.18z"}}),_c('path',{attrs:{"d":"M10.35 5a5.32 5.32 0 105.31 5.32A5.32 5.32 0 0010.35 5zm0 8.76a3.45 3.45 0 113.44-3.44 3.44 3.44 0 01-3.44 3.47zM17.11 4.82a1.24 1.24 0 01-2.48 0 1.24 1.24 0 112.48 0z"}})])])])
          )
        }
      }
    